import React from "react";

const FaqItem = ({ title, description }) => {
    return (
        <div className="bg-gray-100 shadow-lg rounded-lg p-4 mb-4 w-full max-w-2xl mx-auto">
            {/* Titre */}
            <h3 className="font-bold text-blue-800 lg:text-3xl sm:text-xl text-lg mb-2">{title}</h3>

            {/* Description avec hauteur fixe et scroll si nécessaire */}
            <p className="text-blue-600 text-center lg:text-lg font-semibold text-xs leading-relaxed g:max-h-44 max-h-44 overflow-y-auto">
                {description}
            </p>
        </div>
    );
};

export default FaqItem;
